function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEDarkstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 18.71875 74.550781 L 14.191406 74.550781 L 14.191406 88.71875 L 18.71875 88.71875 C 22.691406 88.71875 25.148438 86 25.148438 81.621094 C 25.148438 77.261719 22.679688 74.550781 18.71875 74.550781 Z M 23.011719 81.621094 C 23.011719 84.839844 21.449219 86.679688 18.71875 86.679688 L 16.269531 86.679688 L 16.269531 76.578125 L 18.71875 76.578125 C 20.320312 76.578125 23.011719 77.230469 23.011719 81.621094 Z M 23.011719 81.621094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 31.539062 77.839844 C 28.539062 77.839844 26.199219 80.289062 26.199219 83.421875 C 26.199219 86.539062 28.53125 88.980469 31.5 88.980469 C 32.761719 88.980469 33.960938 88.441406 34.820312 87.511719 L 34.820312 88.71875 L 36.859375 88.71875 L 36.859375 83.421875 C 36.859375 80.289062 34.519531 77.839844 31.539062 77.839844 Z M 34.769531 83.421875 C 34.769531 85.390625 33.320312 87 31.53125 87 C 29.710938 87 28.289062 85.429688 28.289062 83.421875 C 28.289062 81.429688 29.738281 79.800781 31.53125 79.800781 C 33.320312 79.808594 34.769531 81.429688 34.769531 83.421875 Z M 34.769531 83.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 40.269531 78.921875 C 39.339844 79.738281 38.851562 80.960938 38.851562 82.449219 L 38.851562 88.71875 L 40.929688 88.71875 L 40.929688 82.410156 C 40.929688 81.558594 41.171875 80.898438 41.648438 80.460938 C 42.160156 79.988281 42.941406 79.789062 43.910156 79.878906 L 44.140625 79.898438 L 44.140625 77.921875 L 43.960938 77.898438 C 42.519531 77.730469 41.199219 78.089844 40.269531 78.921875 Z M 40.269531 78.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 55.550781 77.960938 L 52.738281 77.960938 L 47.589844 83.160156 L 47.589844 74.351562 L 45.460938 74.351562 L 45.460938 88.851562 L 47.589844 88.851562 L 47.589844 85.941406 L 49.078125 84.46875 L 52.5 88.851562 L 55.179688 88.851562 L 50.589844 83 Z M 55.550781 77.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 60.691406 82.351562 C 58.75 81.71875 58.261719 81.5 58.261719 80.871094 C 58.261719 80 59.21875 79.691406 60.039062 79.691406 C 60.910156 79.691406 61.871094 80.011719 62.820312 80.609375 L 63.089844 80.78125 L 64.140625 79.089844 L 63.878906 78.921875 C 62.699219 78.140625 61.328125 77.71875 60.039062 77.71875 C 57.738281 77.71875 56.128906 79.089844 56.128906 81.050781 C 56.128906 82.648438 57.089844 83.488281 59.800781 84.269531 C 61.25 84.691406 62.140625 84.980469 62.140625 85.820312 C 62.140625 86.589844 61.359375 87.101562 60.199219 87.101562 C 59.140625 87.101562 58.039062 86.691406 56.921875 85.871094 L 56.660156 85.679688 L 55.519531 87.28125 L 55.75 87.46875 C 56.988281 88.46875 58.648438 89.070312 60.191406 89.070312 C 62.578125 89.070312 64.261719 87.671875 64.261719 85.660156 C 64.269531 83.46875 62.28125 82.851562 60.691406 82.351562 Z M 60.691406 82.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 68.5 86.339844 C 68.160156 86.019531 67.980469 85.5 67.980469 84.800781 L 67.980469 80.128906 L 70.300781 80.128906 L 70.300781 78.109375 L 67.980469 78.109375 L 67.980469 75.929688 L 65.898438 75.929688 L 65.898438 84.800781 C 65.898438 86.128906 66.320312 87.210938 67.109375 87.910156 C 67.738281 88.46875 68.578125 88.769531 69.550781 88.769531 C 69.75 88.769531 69.949219 88.761719 70.160156 88.730469 L 70.339844 88.710938 L 70.339844 86.761719 L 70.121094 86.769531 C 69.390625 86.820312 68.851562 86.671875 68.5 86.339844 Z M 68.5 86.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 76.421875 77.851562 C 73.429688 77.851562 71.078125 80.308594 71.078125 83.449219 C 71.078125 86.558594 73.429688 88.988281 76.421875 88.988281 C 79.421875 88.988281 81.761719 86.558594 81.761719 83.449219 C 81.761719 80.308594 79.410156 77.851562 76.421875 77.851562 Z M 79.648438 83.449219 C 79.648438 85.378906 78.199219 86.949219 76.410156 86.949219 C 74.640625 86.949219 73.191406 85.378906 73.191406 83.449219 C 73.191406 81.480469 74.628906 79.871094 76.410156 79.871094 C 78.199219 79.878906 79.648438 81.480469 79.648438 83.449219 Z M 79.648438 83.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 84.789062 78.929688 C 83.859375 79.75 83.371094 80.980469 83.371094 82.460938 L 83.371094 88.730469 L 85.449219 88.730469 L 85.449219 82.421875 C 85.449219 81.570312 85.691406 80.910156 86.171875 80.46875 C 86.679688 80 87.46875 79.800781 88.429688 79.890625 L 88.660156 79.910156 L 88.660156 77.929688 L 88.480469 77.910156 C 87.03125 77.738281 85.71875 78.101562 84.789062 78.929688 Z M 84.789062 78.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 99 83.96875 C 99 80.261719 97.089844 77.960938 94.03125 77.960938 C 91.128906 77.960938 88.871094 80.351562 88.871094 83.390625 C 88.871094 86.421875 91.25 88.878906 94.171875 88.878906 C 95.511719 88.878906 97.378906 88.320312 98.359375 87.25 L 98.53125 87.058594 L 97.269531 85.71875 L 97.070312 85.941406 C 96.5 86.570312 95.238281 87.039062 94.148438 87.039062 C 92.511719 87.039062 91.25 85.921875 90.941406 84.230469 L 99 84.230469 Z M 90.960938 82.410156 C 91.308594 80.839844 92.53125 79.789062 94.078125 79.789062 C 95.660156 79.789062 96.710938 80.738281 96.988281 82.410156 Z M 90.960938 82.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 3.839844 78.679688 C 1.351562 80.171875 0.628906 83.378906 2.191406 85.988281 C 3.738281 88.589844 7.050781 89.488281 9.550781 87.988281 C 10.699219 87.300781 12.019531 85.859375 12.320312 84.441406 L 12.371094 84.191406 L 10.601562 83.679688 L 10.539062 83.96875 C 10.371094 84.800781 9.53125 85.851562 8.601562 86.410156 C 7.191406 87.25 5.53125 86.941406 4.398438 85.648438 L 11.328125 81.511719 L 11.191406 81.269531 C 9.289062 78.109375 6.46875 77.109375 3.839844 78.679688 Z M 3.488281 84.078125 C 2.980469 82.550781 3.5 81.03125 4.828125 80.230469 C 6.179688 79.421875 7.570312 79.699219 8.671875 80.980469 Z M 3.488281 84.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.843137%,66.666667%,62.352941%)",
      fillOpacity: 1
    },
    d: "M 61.089844 38.351562 L 29.601562 25.28125 C 29.601562 25.28125 25.878906 34.191406 33.171875 37.230469 L 57.378906 47.269531 C 60.558594 48.589844 64.058594 46.25 64.058594 42.808594 C 64.070312 40.859375 62.890625 39.101562 61.089844 38.351562 Z M 61.089844 38.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.843137%,66.666667%,62.352941%)",
      fillOpacity: 1
    },
    d: "M 64.691406 26.75 L 24.949219 10.210938 C 24.949219 10.210938 21.230469 19.121094 28.519531 22.160156 L 59.261719 34.910156 C 62.46875 36 66.539062 39.539062 66.539062 45.128906 C 66.539062 51.328125 61.558594 55.839844 55.789062 55.839844 C 52.121094 55.839844 45.039062 55.660156 45.039062 55.660156 C 45.039062 55.660156 45.019531 47.160156 45.019531 44.800781 L 35.808594 40.96875 C 35.808594 45.589844 35.761719 65.53125 35.761719 65.53125 C 35.761719 65.53125 47.371094 65.53125 55.789062 65.53125 C 65.421875 65.53125 76.371094 57.5 76.371094 45.128906 C 76.359375 35.691406 69.859375 29.320312 64.691406 26.75 Z M 64.691406 26.75 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEDarkstore);
export default __webpack_public_path__ + "static/media/logo_eDarkstore.dafe71a73e659fa812faf8826bcf2c87.svg";
export { ForwardRef as ReactComponent };